export default () => ({
  recommendations: [],
  recommendation: null
})



// WEBPACK FOOTER //
// ./src/store/modules/calibrate/state.js